import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"

// === FETCH DATA ===
export const useSettingEsgMatricesTemplate = () => {
  return useQuery({
    queryKey: ['clientesgtemplateslookup'],
    retry: false,
    queryFn: async ({ signal }) => {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SERVER}/client-esg-templates-lookup`,
        method: 'GET',
        withCredentials: true,
        signal,
      })
      return response?.data?.data ?? {}
    },
  })
}

// === UPSERT ===
export const useEsgMatrixUpsert = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['esg-matrix-upsert'],
    retry: false,
    mutationFn: async (data) =>
      axios({
        url: `${process.env.REACT_APP_BASE_SERVER}/client-esg-matrices`,
        method: 'POST',
        withCredentials: true,
        data,
      }).then((res) => res?.data ?? {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clientesgtemplateslookup'] })
    },
  })
}

// === DELETE ===
export const useEsgMatrixDelete = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['esg-matrix-delete'],
    retry: false,
    mutationFn: async (data) =>
      axios({
        url: `${process.env.REACT_APP_BASE_SERVER}/client-esg-matrix-delete`,
        method: 'POST',
        withCredentials: true,
        data,
      }).then((res) => res?.data ?? {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clientesgtemplateslookup'] })
    },
  })
}